/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiServiceUsageReport } from '../models/AiServiceUsageReport';
import type { ClientMtUsageReport } from '../models/ClientMtUsageReport';
import type { ClientsByEnabledAppBundleReport } from '../models/ClientsByEnabledAppBundleReport';
import type { ClientsByEnabledApplicationReport } from '../models/ClientsByEnabledApplicationReport';
import type { EnabledApplicationsByClientReport } from '../models/EnabledApplicationsByClientReport';
import type { GetJobRequestFileDownloadUrlResponse } from '../models/GetJobRequestFileDownloadUrlResponse';
import type { MtBillingType } from '../models/MtBillingType';
import type { QueryMetricResponse } from '../models/QueryMetricResponse';
import type { QuoteRejectionReasonsReport } from '../models/QuoteRejectionReasonsReport';
import type { ReportJob } from '../models/ReportJob';
import type { ReportJobCollection } from '../models/ReportJobCollection';
import type { ReportJobStatus } from '../models/ReportJobStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MetricsService {
    /**
     * Endpoint for fetching machine translation request counts
     * @returns QueryMetricResponse successful operation
     * @throws ApiError
     */
    public static getRequestCounts({
        clientId,
        durationMinutes,
        startTime,
        endTime,
    }: {
        clientId: string,
        /**
         * duration of time frame for search from now back n minutes
         */
        durationMinutes?: number,
        /**
         * start time of time range search in ISO-8601 format
         */
        startTime?: string,
        /**
         * end time of time range search in ISO-8601 format
         */
        endTime?: string,
    }): CancelablePromise<QueryMetricResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/machineTranslation/requestCounts',
            query: {
                'clientId': clientId,
                'durationMinutes': durationMinutes,
                'startTime': startTime,
                'endTime': endTime,
            },
        });
    }
    /**
     * Endpoint for generating a report of applications enabled by a client
     * @returns EnabledApplicationsByClientReport successful operation
     * @throws ApiError
     */
    public static getEnabledApplicationsByClientReport({
        clientId,
        pageToken,
        pageSize,
    }: {
        clientId?: string,
        pageToken?: string,
        pageSize?: number,
    }): CancelablePromise<EnabledApplicationsByClientReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/applications/enabledApplicationsByClientReport',
            query: {
                'clientId': clientId,
                'pageToken': pageToken,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Endpoint for generating a report of clients that have a provided application enabled
     * @returns ClientsByEnabledApplicationReport successful operation
     * @throws ApiError
     */
    public static getClientsByEnabledApplicationReport({
        applicationId,
        pageToken,
        pageSize,
    }: {
        applicationId: string,
        pageToken?: string,
        pageSize?: number,
    }): CancelablePromise<ClientsByEnabledApplicationReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/applications/clientsByEnabledApplicationReport',
            query: {
                'applicationId': applicationId,
                'pageToken': pageToken,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Endpoint for generating a report of clients that have a provided application bundle enabled
     * @returns ClientsByEnabledAppBundleReport successful operation
     * @throws ApiError
     */
    public static getClientsByEnabledAppBundleReport({
        appBundleId,
        pageToken,
        pageSize,
    }: {
        appBundleId: string,
        pageToken?: string,
        pageSize?: number,
    }): CancelablePromise<ClientsByEnabledAppBundleReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/applications/clientsByEnabledAppBundleReport',
            query: {
                'appBundleId': appBundleId,
                'pageToken': pageToken,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Endpoint for fetching machine translation monthly report
     * @returns ClientMtUsageReport successful operation
     * @throws ApiError
     */
    public static getMtMonthlyReport({
        year,
        month,
        pageToken,
        pageSize,
    }: {
        year: number,
        month: number,
        pageToken?: string,
        pageSize?: number,
    }): CancelablePromise<ClientMtUsageReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/machineTranslation/monthlyReport',
            query: {
                'year': year,
                'month': month,
                'pageToken': pageToken,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Endpoint for fetching machine translation report for clients
     * @returns ClientMtUsageReport successful operation
     * @throws ApiError
     */
    public static getClientMtUsageReport({
        fromDate,
        toDate,
        pageToken,
        pageSize,
        billingType,
    }: {
        fromDate: string,
        toDate?: string,
        pageToken?: string,
        pageSize?: number,
        billingType?: MtBillingType,
    }): CancelablePromise<ClientMtUsageReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/machineTranslation/clientMtUsageReport',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
                'pageToken': pageToken,
                'pageSize': pageSize,
                'billingType': billingType,
            },
        });
    }
    /**
     * Create a new asynchronous client MT usage report
     * @returns ReportJob Report creation initiated successfully
     * @throws ApiError
     */
    public static createClientMtUsageReport({
        requestBody,
    }: {
        requestBody: {
            /**
             * Start date for the report (ISO 8601 format)
             */
            fromDate: string;
            /**
             * End date for the report (ISO 8601 format)
             */
            toDate?: string;
            /**
             * When provided, the report includes all clients of that billing type (including those with zero usage).
             * When omitted, the report includes only clients that actually used MT services in the date range.
             *
             */
            billingType?: MtBillingType;
        },
    }): CancelablePromise<ReportJob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/metrics/machineTranslation/clientMtUsageReports',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Endpoint for fetching AI service usage analytics report
     * @returns AiServiceUsageReport successful operation
     * @throws ApiError
     */
    public static getAiServiceUsageReport({
        clientId,
        fromDate,
        toDate,
        pageToken,
        pageSize,
    }: {
        clientId: string,
        fromDate: string,
        toDate?: string,
        pageToken?: string,
        pageSize?: number,
    }): CancelablePromise<AiServiceUsageReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/aiServiceUsage',
            query: {
                'clientId': clientId,
                'fromDate': fromDate,
                'toDate': toDate,
                'pageToken': pageToken,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Endpoint for fetching quote rejection reasons report
     * @returns QuoteRejectionReasonsReport successful operation
     * @throws ApiError
     */
    public static getQuoteRejectionReasonsReport({
        fromDate,
        toDate,
    }: {
        fromDate: string,
        toDate?: string,
    }): CancelablePromise<QuoteRejectionReasonsReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/quotes/rejectionReasonsReport',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
        });
    }
    /**
     * Create a new client contacts metrics report
     * @returns ReportJob Report creation initiated successfully
     * @throws ApiError
     */
    public static createClientContactsReport(): CancelablePromise<ReportJob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/metrics/clientContacts',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create a new file types by client report for Document Translation requests
     * @returns ReportJob Report creation initiated successfully
     * @throws ApiError
     */
    public static createFileTypesByClientReport({
        requestBody,
    }: {
        requestBody: {
            /**
             * Start date for the report (ISO 8601 format)
             */
            fromDate: string;
            /**
             * End date for the report (ISO 8601 format). Defaults to current time if not provided.
             */
            toDate?: string;
        },
    }): CancelablePromise<ReportJob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/metrics/fileTypesByClient',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create a new LQA Rating Analytics report for job requests with MT origination
     * @returns ReportJob Report creation initiated successfully
     * @throws ApiError
     */
    public static createLqaRatingAnalyticsReport({
        requestBody,
    }: {
        requestBody: {
            /**
             * Client ID to generate the report for
             */
            clientId: string;
            /**
             * Start date for the report (ISO 8601 format)
             */
            fromDate: string;
            /**
             * End date for the report (ISO 8601 format). Defaults to current time if not provided.
             */
            toDate?: string;
        },
    }): CancelablePromise<ReportJob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/metrics/lqaRatingAnalytics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List all report jobs
     * @returns ReportJobCollection List of report jobs retrieved successfully
     * @throws ApiError
     */
    public static listReportJobs({
        type,
        pageToken,
        pageSize,
        status,
    }: {
        /**
         * Filter by report type (e.g. CLIENT_CONTACTS)
         */
        type?: string,
        pageToken?: string,
        pageSize?: number,
        status?: ReportJobStatus,
    }): CancelablePromise<ReportJobCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/reportJobs',
            query: {
                'type': type,
                'pageToken': pageToken,
                'pageSize': pageSize,
                'status': status,
            },
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get report job details and download links
     * @returns ReportJob Report job details retrieved successfully
     * @throws ApiError
     */
    public static getReportJob({
        reportId,
    }: {
        reportId: string,
    }): CancelablePromise<ReportJob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/reportJobs/{reportId}',
            path: {
                'reportId': reportId,
            },
            errors: {
                404: `Report job not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete a report job and cleanup associated S3 files
     * @returns void
     * @throws ApiError
     */
    public static deleteReportJob({
        reportId,
    }: {
        reportId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/metrics/reportJobs/{reportId}',
            path: {
                'reportId': reportId,
            },
            errors: {
                404: `Report job not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Cancel a running report job by stopping the Step Function execution
     * @returns ReportJob Report job cancelled successfully
     * @throws ApiError
     */
    public static cancelReportJob({
        reportId,
    }: {
        reportId: string,
    }): CancelablePromise<ReportJob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/metrics/reportJobs/{reportId}/actions/cancel',
            path: {
                'reportId': reportId,
            },
            errors: {
                400: `Report job cannot be cancelled in its current state`,
                404: `Report job not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Securely download a report job file with authentication
     * @returns GetJobRequestFileDownloadUrlResponse Temporary download URL generated successfully
     * @throws ApiError
     */
    public static downloadReportJobFile({
        reportId,
        s3Key,
    }: {
        reportId: string,
        /**
         * URL-encoded S3 key of the file to download
         */
        s3Key: string,
    }): CancelablePromise<GetJobRequestFileDownloadUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/reportJobs/{reportId}/files/{s3Key}/download',
            path: {
                'reportId': reportId,
                's3Key': s3Key,
            },
            errors: {
                400: `Bad request`,
                403: `Access forbidden`,
                404: `Report job or file not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Proxy OpenSearch search operation for a given index
     * Accepts an arbitrary OpenSearch query body and returns the raw OpenSearch response. This endpoint is useful for advanced analytics and troubleshooting.
     * @returns any OpenSearch search response
     * @throws ApiError
     */
    public static searchIndex({
        indexName,
        requestBody,
    }: {
        /**
         * Name of the OpenSearch index to search
         */
        indexName: 'app-events-v2',
        /**
         * OpenSearch query body (passed through as-is)
         */
        requestBody: Record<string, any>,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/metrics/indexes/{indexName}/actions/search',
            path: {
                'indexName': indexName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - invalid query body`,
                500: `Internal server error`,
            },
        });
    }
}
